import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { defaultDoc } from '../share/defaultDoc';

export interface TrafficSafetyScore {
  readonly name: string;
  readonly id: string;
  readonly discipline: number;
  readonly sort: number;
  readonly isActive: boolean;
  readonly dateModified: string;
}

export const trafficSafetyScoreSchema: RxJsonSchema<TrafficSafetyScore> = {
  type: 'object',
  version: 0,
  description: 'describes Traffic Safety',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};

export type TrafficSafetyScoreCollection = RxCollection<TrafficSafetyScore> | null;
export type TrafficSafetyScoreDocument = RxDocument<TrafficSafetyScore>;

export const trafficSafetyScorePullQueryBuilder = (document: TrafficSafetyScore) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query trafficSafetyScoreFeed($lastRequested: DateTime) {
      trafficSafetyScoreFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};

export default {};
